import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'nr-mobile-more-actions',
  imports: [TranslatePipe],
  templateUrl: './mobile-more-actions.html',
  styleUrl: './mobile-more-actions.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MobileMoreActionsComponent {}
